import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import TournamentsView from "../Tournaments/TournamentsView"
import { URLS } from "@twire/utility/constants";
import { getFullRoute } from "@twire/utility/helpers";

const Ppts: React.FC<{ url: string }> = ({ url }) => (
  <Switch>
    <Route
      path={`${url}/ppt_scrim`}
      exact
      render={() => (
        <TournamentsView pptType="ppt_scrim" type="ongoing" mode="ppt" />
      )}
    />
    <Route
       path={`${url}/ppt_cup`}
       exact
      render={() => (
        <TournamentsView pptType="ppt_cup" type="ongoing" mode="ppt" />
      )}
    />
     <Route
       path={`${url}/ppt_master`}
       exact
      render={() => (
        <TournamentsView pptType="ppt_master" type="ongoing" mode="ppt" />
      )}
    />
   <Route
      path={`${url}`}
      exact
      render={() => <Redirect to={`${url}/ppt_scrim`} />}
    />
    <Redirect to={getFullRoute(URLS.PPT_SCRIMS)} />
  </Switch>
);



export default Ppts;
